<mat-card *ngIf="editContacteData" class="contacte-card">
  <form #loginForm="ngForm">
    
    <div class="toolbar-header">
      <div class="spacer"></div> <button mat-icon-button type="button" (click)="desar()" matTooltip="{{ 'contacteDialog.desarToolTip' | translate }}" attr.aria-label="{{ 'contacteDialog.desarToolTip' | translate }}">
        <mat-icon color="primary">save</mat-icon>
      </button>
      <button mat-icon-button type="button" (click)="close()" matTooltip="{{ 'common.tancar' | translate }}" attr.aria-label="{{ 'common.tancar' | translate }}">
        <mat-icon color="primary">close</mat-icon>
      </button>
    </div>

    <mat-progress-bar mode="indeterminate" color="accent" *ngIf="showAsyncProgress"></mat-progress-bar>

    <mat-card-content class="form-container">
      <h2 class="section-title">{{ 'contacteDialog.titolDades' | translate }}</h2>

      <div class="form-row">
        <mat-form-field appearance="fill" class="flex-grow-2">
          <mat-label>{{ 'facturacio.camps.empresa' | translate }}</mat-label>
          <input matInput [(ngModel)]="editContacteData.empresa" name="empresa" [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let client of tbEmpreses" [value]="client.nom">{{client.nom}}</mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field appearance="fill" class="flex-1">
          <mat-label>{{ 'propostaMi.camps.ambit' | translate }}</mat-label>
          <mat-select multiple [(ngModel)]="ambit" name="ambit">
            <mat-option value="Catalunya">{{ 'resumTreballs.catalunya' | translate }}</mat-option>
            <mat-option value="Espanya">{{ 'resumTreballs.espanya' | translate }}</mat-option>
            <mat-option value="Europa">{{ 'resumTreballs.europa' | translate }}</mat-option>
            <mat-option value="Internacional">{{ 'resumTreballs.internacional' | translate }}</mat-option>
            </mat-select>
        </mat-form-field>
      </div>

      <div class="tematiques-section">
        <h3>{{ 'contacteDialog.tematiques' | translate }}</h3>
        <div class="grid-layout">
          <mat-form-field appearance="fill">
            <mat-label>{{ 'projectsList.campsCerca.serveis' | translate }}</mat-label>
            <mat-select multiple name="tematica2" [(ngModel)]="tematica2">
              <mat-option *ngFor="let item of possibleTematiques2" [value]="item.tematica2">{{item.tematica2}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>{{ 'projectsList.campsCerca.sectors' | translate }}</mat-label>
            <mat-select multiple name="tematica3" [(ngModel)]="tematica3">
              <mat-option *ngFor="let item of possibleTematiques3" [value]="item.tematica3">{{item.tematica3}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>{{ 'projectsList.campsCerca.tipusEspecific' | translate }}</mat-label>
            <mat-select multiple name="tematica1" [(ngModel)]="tematica1">
              <mat-option *ngFor="let item of possibleTematiques1" [value]="item.tematica1">{{item.tematica1}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>{{ 'projectsList.campsCerca.sectorEspecific' | translate }}</mat-label>
            <mat-select multiple name="tematica4" [(ngModel)]="tematica4">
              <mat-option *ngFor="let item of possibleTematiques4" [value]="item.tematica4">{{item.tematica4}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>{{ 'projectsList.campsCerca.sistemes' | translate }}</mat-label>
            <mat-select multiple name="tematica5" [(ngModel)]="tematica5">
              <mat-option *ngFor="let item of possibleTematiques5" [value]="item.tematica5">{{item.tematica5}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="form-row">
        <mat-form-field appearance="fill" class="flex-grow-2">
          <mat-label>{{ 'usuaris.colNom' | translate }}</mat-label>
          <input matInput name="nom" [(ngModel)]="editContacteData.nom">
        </mat-form-field>
        <mat-form-field appearance="fill" class="flex-1">
          <mat-label>{{ 'usuaris.colCarrec' | translate }}</mat-label>
          <input matInput name="tipus" [(ngModel)]="editContacteData.tipus">
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="fill" class="flex-grow-2">
          <mat-label>{{ 'clientsSocis.cmpadreca' | translate }}</mat-label>
          <input matInput name="adreca" [(ngModel)]="editContacteData.adreca">
        </mat-form-field>
        <mat-form-field appearance="fill" class="flex-1">
          <mat-label>{{ 'usuaris.colTelefon' | translate }}</mat-label>
          <input matInput name="tlf" [(ngModel)]="editContacteData.tlf">
        </mat-form-field>
        <mat-form-field appearance="fill" class="flex-1">
          <mat-label>{{ 'contacteDialog.mobil' | translate }}</mat-label>
          <input matInput name="mobil" [(ngModel)]="editContacteData.mobil">
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="fill" class="flex-grow-2">
          <mat-label>{{ 'clientsSocis.cmpmail' | translate }}</mat-label>
          <input matInput type="email" name="email" [(ngModel)]="editContacteData.email">
        </mat-form-field>
        <mat-form-field appearance="fill" class="flex-grow-1">
          <mat-label>LinkedIn</mat-label>
          <input matInput name="linkedin" [(ngModel)]="editContacteData.linkedin">
        </mat-form-field>
      </div>

      <mat-form-field appearance="fill" class="full-width">
        <mat-label>{{ 'clientsSocis.cmpcomentaris' | translate }}</mat-label>
        <textarea matInput name="comentari" rows="3" [(ngModel)]="editContacteData.comentari"></textarea>
      </mat-form-field>

      <div class="checkbox-container" *ngIf="editContacteData.id === 'NEW'">
        <mat-checkbox color="primary" name="professional" [(ngModel)]="editContacteData.professional">{{ 'contacteDialog.professionalIndependent' | translate }}</mat-checkbox>
      </div>

      <hr class="divider">

      <div class="form-row align-center">
        <mat-form-field appearance="fill" class="flex-1">
          <mat-label>{{ 'propostaMi.dates.data' | translate }}</mat-label>
          <input matInput name="dia" type="date" [(ngModel)]="dia">
        </mat-form-field>
        <button mat-mini-fab color="primary" type="button" (click)="afegir(null)" matTooltip="{{ 'propostaMi.seguiment.afegirDataToolTip' | translate }}" attr.aria-label="{{ 'propostaMi.seguiment.afegirDataToolTip' | translate }}" style="margin-bottom: 15px;">
          <mat-icon>note_add</mat-icon>
        </button>
        <mat-form-field appearance="fill" class="flex-grow-2">
          <mat-label>{{ 'notesDialeg.projectesPlaceholder' | translate }}</mat-label>
          <mat-select (selectionChange)="afegir($event)">
            <mat-option *ngFor="let p of projectes" [value]="p.value">{{p.value}} - {{p.text}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="editor-container">
        <label class="editor-label">{{ 'contacteDialog.notesLabel' | translate }}</label>
        <quill-editor #quillEditor [styles]="{height: '350px', background: '#fafafa'}" [(ngModel)]="editContacteData.nota" name="nota" (onSelectionChanged)="setPos($event)"></quill-editor>
      </div>
    </mat-card-content>
  </form>
</mat-card>
